import { useProjects } from "@hq/client-react";
import type { Project } from "@hq/contracts";

export type ProjectIndex = {
  projects: readonly Project[];
  names: ReadonlyMap<string, string>;
};

const NONE: readonly Project[] = [];

/** Active projects plus an id→name map for row chips and group headings. */
export function useProjectIndex(): ProjectIndex {
  const { data } = useProjects({ status: ["active"] });
  const projects = data ?? NONE;
  return { projects, names: new Map(projects.map((p) => [p.id, p.name])) };
}
